module.exports = __webpack_public_path__ + "img/Twitter.606f3f2b.png";